import { render } from "./RedpackInfoSymbol.vue?vue&type=template&id=eabfdd0c&scoped=true&ts=true"
import script from "./RedpackInfoSymbol.vue?vue&type=script&lang=ts"
export * from "./RedpackInfoSymbol.vue?vue&type=script&lang=ts"

import "./RedpackInfoSymbol.vue?vue&type=style&index=0&id=eabfdd0c&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eabfdd0c"]])

export default __exports__